import { Component, ContentChild, input, output, signal, TemplateRef } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { NgTemplateOutlet } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
	selector: 'app-table-form-container',
	imports: [NgTemplateOutlet, NzSpinModule, NzButtonModule],
	standalone: true,
	templateUrl: './table-form-container.html',
	styleUrl: './table-form-container.scss',
})
export class TableFormContainer {
	@ContentChild('tableTemplate', { static: false }) tableTemplate!: TemplateRef<any>;
	@ContentChild('formTemplate', { static: false }) formTemplate!: TemplateRef<any>;

	loading = input<boolean>(true);
	showForm = input<boolean>(false);
	modelName = input<string>('Item');
	isAdmin = signal<boolean>(false);
	onShowForm = output<void>();
	onHideForm = output<void>();

	constructor(public authService: AuthService) {
		this.authService.isAdmin$().then((isAdmin: boolean) => {
			this.isAdmin.set(isAdmin);
		});

	}

	public requestShowForm(): void {
		this.onShowForm.emit();
	}

	public hideForm(): void {
		this.onHideForm.emit();
	}
}
